export default function release(appName) {
  /* eslint-disable no-underscore-dangle */
  window.__APPS__ = window.__APPS__ || {};
  window.__APPS__[appName] = {
    date: process.env.CI_RELEASE_DATE,
    branch: process.env.CI_COMMIT_REF_NAME,
    commit: process.env.CI_COMMIT_SHORT_SHA || "development",
  };
  /* eslint-enable no-underscore-dangle */
}
